<template>
  <!-- Modal -->
  <div class="modal fade" :id="name" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Enter JSON Tasks</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form-textarea label="JSON Tasks" name="tasks" v-model="tasks" validation="required|json-no-nulls"></form-textarea>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button v-on:click="addJsonTasks" type="button" class="btn btn-success">Add</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import FormTextArea from '../../../elements/Form/FormTextArea'
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';

Vue.use(VeeValidate);

export default {
  components: {
    'form-textarea':FormTextArea
  },
  props: {
    name: {
      type: String
    }
  },
  data() {
    return {
      tasks: "{}",
    }
  },
  created: function(){
    var self = this
    Validator.extend('json-no-nulls', {
      getMessage: field => 'The ' + field + ' field must be in a valid JSON format.',
      validate(value, args) {
        try {
          var parsed = JSON.parse(value);
          
          for (var i = 0; i < parsed.length; i++) { 
            if (parsed[i] != null){
              continue
            } else {
              return false
            }
          }
          return true
        } catch (error) {
          return false;
        }
      }
    });
  },
  methods: {
    showAllTasks: function(){
      this.selectedTask = 'none'
    },
    selectTask: function(task) {
       var task = task.replace(/\s+/g, '');
       task = task.toLowerCase()
       this.selectedTask = task
    },
    addJsonTasks:function(){
      try {
        var parsed = JSON.parse(this.tasks);
        
        for (var i = 0; i < parsed.length; i++) { 
          if (parsed[i] != null){
            continue
          } else {
            throw SyntaxError("Unexpected null value as child of JSON array")
          }
        }
        //console.log("Worked")
        this.$emit('addJsonTasks', parsed)
        $('#addJsonTasksModal').modal('toggle')
      } catch (error) {
        //console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.task p{
  color: #000
}
.task small{
  color: #000
}
.task:hover {
    z-index: 2;
    color: #fff;
    background-color: #46B3E4;
    border-color: #46B3E4;
}
.task:hover p {
  color: #fff
}
.task:hover small {
  color: #fff
}
</style>

<!-- <template>
  <!-- Modal --
  <div class="modal fade" :id="name" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form v-on:submit="addJsonTasks">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Enter JSON Tasks</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form-textarea label="JSON Tasks" name="tasks" v-model="tasks" validation="required|json-no-nulls"></form-textarea>
          </div>
          <div class="modal-footer">
            <div class="form-group">
              <!-- TODO: Uhm if I put data-dismiss="modal" it doesn't work but if I take it out it doesn't submit.... --
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-success">Add</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import LocationTag from './LocationTag'
import Input from './Input'
import FormTextArea from '../../../elements/Form/FormTextArea'
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';

Vue.use(VeeValidate);

export default {
  components: {
    'locationtag':LocationTag,
    'datainput':Input,
    'form-textarea':FormTextArea
  },
  props: {
    name: {
      type: String
    }
  },
  data() {
    return {
      tasks: "{}",
    }
  },
c
  methods: {
    showAllTasks: function(){
      this.selectedTask = 'none'
    },
    selectTask: function(task) {
       var task = task.replace(/\s+/g, '');
       task = task.toLowerCase()
       this.selectedTask = task
    },
    addJsonTasks:function(){
      var promises = [];
      var self = this;
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        try {
          var parsed = JSON.parse(self.tasks);
          
          for (var i = 0; i < parsed.length; i++) { 
            if (parsed[i] != null){
              continue
            } else {
              throw "There is a null!"
            }
          }
          console.log("Worked")
          self.$emit('addJsonTasks', parsed)
          //$('#name').modal('toggle')
        } catch (error) {
          console.log(error)
        }
        
      }, () => {});
    }
  }
}
</script>

<style scoped>
.task p{
  color: #000
}
.task small{
  color: #000
}
.task:hover {
    z-index: 2;
    color: #fff;
    background-color: #46B3E4;
    border-color: #46B3E4;
}
.task:hover p {
  color: #fff
}
.task:hover small {
  color: #fff
}
</style> -->


// WEBPACK FOOTER //
// AddJsonTasksModal.vue?6bac0a2c